module.exports = __webpack_public_path__ + "static/media/variant-display-banner.0e21fa21.png";